import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { LARGURA_DE_LEITURA } from '../layout';

/**
 * O desenho da tela enquanto o número não chegou.
 *
 * Spinner no meio do conteúdo diz "espere" e some com a página inteira; o
 * esqueleto diz "é aqui que o seu número vai aparecer" e mantém o layout no
 * lugar, sem o pulo que faz o usuário perder o ponto de leitura quando o dado
 * entra. Ele repete a estrutura real das telas de leitura: um bloco de destaque
 * em cima, dois blocos de lista embaixo.
 */
const EsqueletoDaTela = () => (
  <Stack spacing={3} sx={{ maxWidth: LARGURA_DE_LEITURA, mx: 'auto' }} aria-busy="true" aria-live="polite">
    <Box sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
      <Skeleton variant="text" width={140} height={18} />
      <Skeleton variant="text" width={220} height={56} sx={{ mt: 1 }} />
      <Skeleton variant="text" width="65%" height={20} sx={{ mt: 1 }} />
      <Stack spacing={1.25} sx={{ mt: 3 }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rounded" height={12} />
        ))}
      </Stack>
    </Box>

    {[0, 1].map((bloco) => (
      <Box key={bloco} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
        <Skeleton variant="text" width={200} height={28} />
        <Skeleton variant="text" width="45%" height={18} sx={{ mt: 0.5 }} />
        <Stack spacing={1.5} sx={{ mt: 2.5 }}>
          {[0, 1, 2].map((linha) => (
            <Stack key={linha} direction="row" justifyContent="space-between" alignItems="center">
              <Skeleton variant="text" width="38%" height={18} />
              <Skeleton variant="text" width={90} height={18} />
            </Stack>
          ))}
        </Stack>
      </Box>
    ))}
  </Stack>
);

export default EsqueletoDaTela;
